import UnitSearchResult from './UnitSearchResult';
export default UnitSearchResult;
